export interface Listing {
  id: string;
  title: string;
  price: number;
  area_m2: number;
  city: string;
  district: string;
  zoning_status: string;
  deed_status: string;
  swap: boolean;
  description: string;
  photos: string[];
  eids_number: string;
  eids_status: "Beklemede" | "Doğrulandı" | "Reddedildi";
  user_type: "Bireysel" | "Emlak Ofisi";
  user_name: string;
  status: "Yayında" | "Onay Bekliyor" | "Reddedildi";
  created_at: string;
  featured: boolean;
  investment_potential?: string;
}

export const listings: Listing[] = [
  {
    id: "1",
    title: "Yatırımlık Konut İmarlı Arsa - Ataşehir'de Fırsat",
    price: 3850000,
    area_m2: 520,
    city: "İstanbul",
    district: "Ataşehir",
    zoning_status: "Konut İmarlı",
    deed_status: "Kat İrtifaklı",
    swap: false,
    description:
      "Ataşehir'in en değerli bölgesinde, metro durağına 300 metre mesafede konut imarlı arsa. 2.30 emsal ile toplam 1.196 m² inşaat hakkı. Cadde cepheli, doğalgaz ve elektrik altyapısı hazır. Yakınında okul, hastane ve alışveriş merkezleri mevcut. Yatırım için ideal fırsat.",
    photos: [
      "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20vacant%20residential%20land%20plot%20in%20modern%20urban%20district%20with%20infrastructure%20ready%20green%20surroundings%20under%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20residential%20neighborhood%20aerial%20view%20with%20green%20parks%20and%20streets%20in%20urban%20area%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Empty%20land%20plot%20with%20construction%20fence%20and%20utility%20poles%20in%20urban%20setting%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=3&orientation=landscape",
    ],
    eids_number: "EİDS-2024-001529",
    eids_status: "Doğrulandı",
    user_type: "Emlak Ofisi",
    user_name: "Mega Emlak",
    status: "Yayında",
    created_at: "2024-03-15T10:30:00Z",
    featured: true,
    investment_potential:
      "Bölgede yeni metro hattı çalışmaları başladı. Değer artışı %40 bekleniyor.",
  },
  {
    id: "2",
    title: "Deniz Manzaralı Tarla - Çeşme Alaçatı Yolu Üzeri",
    price: 2750000,
    area_m2: 15000,
    city: "İzmir",
    district: "Çeşme",
    zoning_status: "Tarla",
    deed_status: "Kat Mülkiyetli",
    swap: true,
    description:
      "Çeşme-Alaçatı yolu üzerinde, deniz manzaralı 15 dönüm tarla. Zeytinlik olarak kullanılmakta, içinde 200 adet verimli zeytin ağacı bulunmaktadır. Elektrik ve su hattı mevcut. Yola cephe, ulaşım kolay. Tarım veya turizm yatırımı için uygundur. Takas düşünülür.",
    photos: [
      "https://readdy.ai/api/search-image?query=Beautiful%20olive%20grove%20with%20rolling%20hills%20and%20sea%20view%20in%20distance%20soft%20golden%20hour%20light%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sunlit%20agricultural%20field%20with%20dirt%20road%20and%20utility%20poles%20rural%20landscape%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20coastal%20farmland%20with%20blue%20sea%20and%20green%20fields%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=6&orientation=landscape",
    ],
    eids_number: "EİDS-2024-002847",
    eids_status: "Doğrulandı",
    user_type: "Bireysel",
    user_name: "Ahmet Yılmaz",
    status: "Yayında",
    created_at: "2024-03-10T14:20:00Z",
    featured: true,
    investment_potential:
      "Çeşme-Alaçatı yolunun genişletme projesi kapsamında. Değer artış potansiyeli yüksek.",
  },
  {
    id: "3",
    title: "Sanayi Bölgesinde Ticari İmarlı Arsa - Organize Sanayi",
    price: 6200000,
    area_m2: 2500,
    city: "Ankara",
    district: "Sincan",
    zoning_status: "Ticari İmarlı",
    deed_status: "Kat İrtifaklı",
    swap: false,
    description:
      "Sincan Organize Sanayi Bölgesi içinde, yola cephe ticari imarlı arsa. 1.50 emsal ile 3.750 m² inşaat hakkı. Doğalgaz, elektrik, su ve kanalizasyon altyapısı tamamlanmış. Kamyon girişine uygun geniş cephe. Depo, fabrika veya ticari yapı için ideal.",
    photos: [
      "https://readdy.ai/api/search-image?query=Empty%20commercial%20land%20plot%20in%20industrial%20zone%20with%20wide%20road%20access%20and%20infrastructure%20ready%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=7&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Industrial%20area%20with%20warehouses%20and%20wide%20roads%20aerial%20view%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=8&orientation=landscape",
    ],
    eids_number: "EİDS-2024-003156",
    eids_status: "Doğrulandı",
    user_type: "Emlak Ofisi",
    user_name: "Capital Emlak",
    status: "Yayında",
    created_at: "2024-03-08T09:15:00Z",
    featured: true,
    investment_potential:
      "OSB genişleme planı dahilinde. Sanayi talebi artıyor, kira getirisi potansiyeli yüksek.",
  },
  {
    id: "4",
    title: "Göl Manzaralı Villa İmarlı Arsa - Sapanca",
    price: 1850000,
    area_m2: 800,
    city: "Sakarya",
    district: "Sapanca",
    zoning_status: "Villa İmarlı",
    deed_status: "Kat Mülkiyetli",
    swap: false,
    description:
      "Sapanca Gölü manzaralı, doğa içinde villa imarlı arsa. 0.25 emsal ile tek villa yapımına uygun. Yola 50 metre mesafe. Elektrik ve su hattı hazır. Site içinde değil, bağımsız parsel. Hafta sonu evi veya yatırım için ideal.",
    photos: [
      "https://readdy.ai/api/search-image?query=Beautiful%20lake%20view%20vacant%20land%20plot%20with%20green%20forest%20surroundings%20and%20calm%20water%20in%20background%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=9&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Serene%20forest%20landscape%20with%20lake%20view%20from%20hilltop%20green%20trees%20and%20blue%20water%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=10&orientation=landscape",
    ],
    eids_number: "EİDS-2024-004203",
    eids_status: "Doğrulandı",
    user_type: "Bireysel",
    user_name: "Mehmet Kaya",
    status: "Yayında",
    created_at: "2024-03-05T11:00:00Z",
    featured: true,
    investment_potential:
      "Sapanca turizm bölgesi talebi artıyor. Villa kiralama getirisi mevsimlik yüksek.",
  },
  {
    id: "5",
    title: "Merkezi Lokasyonda Dükkan İmarlı Arsa - Taksim Yakını",
    price: 9500000,
    area_m2: 150,
    city: "İstanbul",
    district: "Beyoğlu",
    zoning_status: "Ticari İmarlı",
    deed_status: "Kat Mülkiyetli",
    swap: false,
    description:
      "Taksim Meydanı'na 500 metre mesafede, ana cadde üzerinde dükkan imarlı arsa. 4.00 emsal ile 600 m² inşaat hakkı. Zemin + 3 kat yapımına uygun. Yoğun yaya trafiği, ticaret potansiyeli yüksek. Tüm altyapı hizmetleri mevcut.",
    photos: [
      "https://readdy.ai/api/search-image?query=Urban%20street%20view%20with%20commercial%20buildings%20and%20pedestrian%20traffic%20in%20city%20center%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=11&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Busy%20city%20center%20street%20with%20shops%20and%20pedestrians%20aerial%20view%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=12&orientation=landscape",
    ],
    eids_number: "EİDS-2024-005891",
    eids_status: "Doğrulandı",
    user_type: "Emlak Ofisi",
    user_name: "Pera Emlak",
    status: "Yayında",
    created_at: "2024-03-01T16:45:00Z",
    featured: true,
    investment_potential:
      "Beyoğlu kentsel dönüşüm projesi kapsamında. Cadde genişletme planı onaylandı.",
  },
  {
    id: "6",
    title: "Yatırımlık Tarla - Bursa Karacabey Ovası",
    price: 1200000,
    area_m2: 25000,
    city: "Bursa",
    district: "Karacabey",
    zoning_status: "Tarla",
    deed_status: "Kat Mülkiyetli",
    swap: true,
    description:
      "Karacabey Ovası'nda, sulama kanallarına yakın 25 dönüm tarla. Verimli toprak, buğday ve ayçiçeği ekimine uygun. Elektrik hattı mevcut, yola cephe. Tarımsal yatırım için ideal. Takas düşünülür.",
    photos: [
      "https://readdy.ai/api/search-image?query=Vast%20green%20agricultural%20field%20with%20irrigation%20canals%20and%20blue%20sky%20horizon%20rural%20landscape%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=13&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Golden%20wheat%20field%20with%20irrigation%20system%20and%20rural%20road%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=14&orientation=landscape",
    ],
    eids_number: "EİDS-2024-006734",
    eids_status: "Doğrulandı",
    user_type: "Bireysel",
    user_name: "Fatma Demir",
    status: "Yayında",
    created_at: "2024-02-28T08:30:00Z",
    featured: false,
    investment_potential: "Bölgede yeni organize sanayi planı var. Değer artışı bekleniyor.",
  },
  {
    id: "7",
    title: "Deniz Kenarında Turizm İmarlı Arsa - Antalya Konyaaltı",
    price: 7500000,
    area_m2: 1200,
    city: "Antalya",
    district: "Konyaaltı",
    zoning_status: "Turizm İmarlı",
    deed_status: "Kat İrtifaklı",
    swap: false,
    description:
      "Konyaaltı Plajı'na 800 metre mesafede turizm imarlı arsa. 0.50 emsal ile 600 m² inşaat hakkı. Butik otel veya apart yapımına uygun. Elektrik, su, kanalizasyon mevcut. Turizm sezonu kira getirisi yüksek.",
    photos: [
      "https://readdy.ai/api/search-image?query=Coastal%20vacant%20land%20with%20palm%20trees%20and%20sea%20view%20near%20beach%20resort%20area%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=15&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Beautiful%20Mediterranean%20coastline%20with%20blue%20water%20and%20sandy%20beach%20tourism%20area%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=16&orientation=landscape",
    ],
    eids_number: "EİDS-2024-007452",
    eids_status: "Doğrulandı",
    user_type: "Emlak Ofisi",
    user_name: "Akdeniz Emlak",
    status: "Yayında",
    created_at: "2024-02-25T13:20:00Z",
    featured: false,
    investment_potential:
      "Antalya turizmi her yıl büyüyor. Kısa süreli kiralama getirisi %8-10/yıl.",
  },
  {
    id: "8",
    title: "Köy İmarlı Arsa - Trabzon Yaylası Manzaralı",
    price: 890000,
    area_m2: 600,
    city: "Trabzon",
    district: "Maçka",
    zoning_status: "Konut İmarlı",
    deed_status: "Kat Mülkiyetli",
    swap: false,
    description:
      "Maçka ilçesinde, yayla manzaralı konut imarlı arsa. 0.30 emsal ile 180 m² inşaat hakkı. Elektrik ve su hattı hazır. Doğa ile iç içe, sessiz ve huzurlu lokasyon. Yazlık ev veya yatırım için uygundur.",
    photos: [
      "https://readdy.ai/api/search-image?query=Mountain%20village%20landscape%20with%20green%20plateau%20view%20and%20traditional%20houses%20in%20distance%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=17&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Green%20mountain%20plateau%20with%20clouds%20and%20forest%20view%20peaceful%20rural%20scene%20soft%20daylight%20minimal%20clean%20background%20high%20quality%20photography&width=800&height=500&seq=18&orientation=landscape",
    ],
    eids_number: "EİDS-2024-008367",
    eids_status: "Beklemede",
    user_type: "Bireysel",
    user_name: "Hasan Çelik",
    status: "Onay Bekliyor",
    created_at: "2024-02-20T10:00:00Z",
    featured: false,
    investment_potential:
      "Karadeniz turizmi yayla turizmi ile büyüyor. Kısa süreli kiralama potansiyeli var.",
  },
];

export const cities = [
  "İstanbul",
  "Ankara",
  "İzmir",
  "Bursa",
  "Antalya",
  "Adana",
  "Konya",
  "Gaziantep",
  "Şanlıurfa",
  "Mersin",
  "Diyarbakır",
  "Kayseri",
  "Samsun",
  "Tekirdağ",
  "Denizli",
  "Sakarya",
  "Trabzon",
  "Eskişehir",
  "Malatya",
  "Erzurum",
];

export const districtsByCity: Record<string, string[]> = {
  İstanbul: [
    "Ataşehir",
    "Kadıköy",
    "Beşiktaş",
    "Beyoğlu",
    "Şişli",
    "Üsküdar",
    "Maltepe",
    "Pendik",
    "Kartal",
    "Sarıyer",
  ],
  Ankara: [
    "Çankaya",
    "Keçiören",
    "Yenimahalle",
    "Mamak",
    "Etimesgut",
    "Sincan",
    "Altındağ",
    "Pursaklar",
  ],
  İzmir: [
    "Konak",
    "Karşıyaka",
    "Bornova",
    "Buca",
    "Çeşme",
    "Alaçatı",
    "Urla",
    "Karabağlar",
    "Gaziemir",
  ],
  Bursa: [
    "Osmangazi",
    "Nilüfer",
    "Yıldırım",
    "İnegöl",
    "Gemlik",
    "Mudanya",
    "Karacabey",
  ],
  Antalya: [
    "Muratpaşa",
    "Konyaaltı",
    "Kepez",
    "Alanya",
    "Manavgat",
    "Serik",
    "Kemer",
    "Kaş",
  ],
  Sakarya: ["Adapazarı", "Serdivan", "Sapanca", "Akyazı", "Hendek", "Geyve"],
  Trabzon: ["Ortahisar", "Akçaabat", "Maçka", "Of", "Vakfıkebir", "Tonya"],
};

export const zoningOptions = [
  "Konut İmarlı",
  "Ticari İmarlı",
  "Sanayi İmarlı",
  "Villa İmarlı",
  "Turizm İmarlı",
  "Tarla",
  "Bağ",
  "Orman",
  "Tarla + Bağ",
];

export const deedOptions = [
  "Kat Mülkiyetli",
  "Kat İrtifaklı",
  "Arsa",
  "Tarla",
  "Devlet Tahsisli",
  "Hisseli",
];

export const categoryGroups = [
  {
    id: "yatirimlik",
    title: "Yatırımlık Arsalar",
    description:
      "Gelecek vaat eden bölgelerde, değer artışı potansiyeli yüksek arsa ilanları.",
    icon: "ri-line-chart-line",
    bgColor: "bg-primary-50",
    textColor: "text-primary-600",
    count: 124,
  },
  {
    id: "imarli",
    title: "İmarlı Arsalar",
    description:
      "Konut, ticari ve sanayi imarlı, yapı ruhsatına hazır arsa ilanları.",
    icon: "ri-building-line",
    bgColor: "bg-accent-50",
    textColor: "text-accent-600",
    count: 89,
  },
  {
    id: "tarla",
    title: "Tarla ve Ziraat",
    description:
      "Tarımsal üretime uygun, sulama imkanı olan tarla ve bağ ilanları.",
    icon: "ri-plant-line",
    bgColor: "bg-emerald-50",
    textColor: "text-emerald-600",
    count: 203,
  },
];